/**
 * Created by huangzhangshu on 2019-07-26
 */

import React from 'react';
import { Spin } from 'antd';
import Indicator from './Indicator';

export interface SpinXProps {
  // 关闭回调方法
  onClose?: () => void;
  // 提示文字
  tip: string;
}

export default class SpinX extends React.Component<SpinXProps> {

  render() {
    const { onClose, tip, children } = this.props;
    const params = {
      ...this.props,
    }
    delete params.tip;
    delete params.children;
    return (
      <Spin indicator={<Indicator onClose={onClose} tip={tip} />} {...params}>
        {children}
      </Spin>
    );
  }
}
